import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, Col } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ChartReport from 'components/charts/Chart';
import AgeCompareChart from 'components/charts/ButterFlyChart';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import { isSameDay } from 'utils/date';

import ParticipationChart from 'components/charts/ParticipationChart';
import ReportLimitBanner from 'components/Banners/reportLimitBanner';
import CategoryApi from 'apis/Category';
import { GENDER_CHART, COMPARE_CHART, AGE_CHART } from 'constants/charts';

import 'assets/scss/chartReport.css';
import { withRouter } from 'react-router';
import BusinessApi from '../../apis/Business';

const genderFilters = [
  { name: 'Male' },
  { name: 'Female' },
  { name: 'Unresponded' },
];

class ChartReportModal extends Component {
  constructor() {
    super();

    this.state = {
      focusedInput: null,
      modalToggle: true,
      seriesData: null,
      startDate: null,
      endDate: null,
      categories: [],
      businessCategories: [],
    };
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const businessId = params.id;
    this.fetchAllCategories(businessId);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      startDate:
        nextProps.dateRange && moment.unix(nextProps.dateRange.startDate),
      endDate: nextProps.dateRange && moment.unix(nextProps.dateRange.endDate),
    });
  }

  fetchAllCategories = async businessId => {
    try {
      const { data } = await CategoryApi.getAll();
      const { data: businessData } = await BusinessApi.getDetails(businessId);
      const businessCategories = businessData.categories;
      const otherCategories = data.filter(({ id }) => {
        const foundCategory = businessCategories.find(cat => cat.id === id);
        return !foundCategory;
      });
      const categories = [...businessCategories, ...otherCategories];
      this.setState({
        categories,
        filterSeperatorIndex: businessCategories.length - 1,
      });
    } catch (err) {
      console.log(err);
    }
  };

  onDateChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  closeModal = e => {
    this.props.handleClose(e);
    this.props.onDateChange(this.state);
  };

  renderDatePresets = () => {
    const { startDate, endDate } = this.props;
    const presets = [
      {
        text: 'This Week',
        start: moment().startOf('week'),
        end: moment().endOf('week'),
      },
      {
        text: 'Last Week',
        start: moment()
          .subtract(1, 'week')
          .startOf('week'),
        end: moment()
          .subtract(1, 'week')
          .endOf('week'),
      },
      {
        text: 'This Month',
        start: moment().startOf('month'),
        end: moment().endOf('month'),
      },
      {
        text: 'Last Month',
        start: moment()
          .subtract(1, 'month')
          .startOf('month'),
        end: moment()
          .subtract(1, 'month')
          .endOf('month'),
      },
    ];

    return (
      <div className="panel">
        {presets.map(({ text, start, end }) => {
          const isSelected =
            isSameDay(start, startDate) && isSameDay(end, endDate);
          return (
            <button
              key={text}
              type="button"
              className={`preset-btn ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                this.onDateChange({ startDate: start, endDate: end });
                this.setState({ focusedInput: null });
              }}
            >
              {text}
            </button>
          );
        })}
      </div>
    );
  };

  closeModal = e => {
    this.props.handleClose(e);
    this.props.onDateChange(this.state);
  };

  render() {
    const { isVisible, question } = this.props;
    const { focusedInput, startDate, endDate, categories, filterSeperatorIndex } = this.state;
    const { question_id: questionId, question_count: questionCount } = question;

    return (
      <Modal
        isOpen={isVisible}
        toggle={this.closeModal}
        className="chart-report-container"
      >
        <ModalHeader
          toggle={this.closeModal}
          className="d-flex jsutify-content-between modal-header"
        >
          {question.question}
          <div className="float-right filters mr-4 daterange-picker">
            <DateRangePicker
              small
              startDateId="startDate"
              endDateId="endDate"
              startDate={startDate}
              endDate={endDate}
              onDatesChange={this.onDateChange}
              focusedInput={focusedInput}
              isOutsideRange={dt => dt.isAfter(moment(), 'day')}
              onFocusChange={focusedInput => {
                this.setState({ focusedInput });
              }}
              showClearDates={startDate || endDate ? true : false}
              renderCalendarInfo={this.renderDatePresets}
            />
            <span className="question-count text-muted ml-4">
              <FontAwesomeIcon className="mr-0" icon="users" /> {questionCount}
            </span>
          </div>
        </ModalHeader>
        <ModalBody className="row py-0">
          <ReportLimitBanner />
          <Col md={6}>
            <ChartReport
              headTitle="Participants Over Time"
              titleText="The amount of participants who respond over time"
              category="participants_over_time"
              chartType="line"
              showGrids
              legendConfig={{ enabled: false }}
              colors={GENDER_CHART}
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
              height={225}
            />
            <ChartReport
              titleText="How participants are responding over time"
              category="answers_over_time"
              chartType="line"
              showGrids
              colors={GENDER_CHART}
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
              height={225}
            />
            <ChartReport
              headTitle="Category Comparison"
              titleText="How participants responded in each category"
              subtitleText="Compared to the average participant"
              chartType="column"
              category="category"
              dataType="comparison"
              filterType="category"
              axisTitle="Percentage of respondants"
              percentage
              colors={COMPARE_CHART}
              filters={categories}
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
              filterSeperatorIndex={filterSeperatorIndex}
            />
            <ChartReport
              headTitle="Participant Comparison"
              titleText="How each gender answered the question"
              subtitleText="Compared to the average participant"
              chartType="column"
              dataType="comparison"
              category="gender"
              filterType="gender"
              axisTitle="Percentage of respondants"
              percentage
              colors={COMPARE_CHART}
              filters={genderFilters}
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
            />
            <AgeCompareChart
              titleText="How each age-group answered the question"
              subtitleText="Compared to the average participant"
              chartType="bar"
              dataType="comparison"
              stacked
              colors={AGE_CHART}
              category="age_range"
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
              height={300}
            />
          </Col>
          <Col md={6}>
            <ParticipationChart
              headTitle="Particpant Demographics"
              titleText="Breakdown of participants who responded to your survey"
              subtitleText="Based on Gender and Age-group"
              questionId={questionId}
              category="demographic_participation"
              startDate={startDate}
              colors={GENDER_CHART}
              endDate={endDate}
              height={250}
            />
            <ChartReport
              titleText="How each gender answered the question"
              category="gender"
              chartType="column"
              colors={GENDER_CHART}
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
              height={250}
            />
            <ChartReport
              titleText="How each age-group answered the question"
              chartType="bar"
              stacked
              legendConfig={{
                align: 'right',
                verticalAlign: 'top',
                layout: 'vertical',
                itemMarginTop: 5,
              }}
              category="age_range"
              colors={AGE_CHART}
              questionId={questionId}
              startDate={startDate}
              endDate={endDate}
            />
          </Col>
        </ModalBody>
      </Modal>
    );
  }
}

ChartReportModal.defaultProps = {
  customSurveyId: '',
  isVisible: false,
  handleClose: () => {},
  question: {},
  onDateChange: () => {},
  dateRange: {},
};

ChartReportModal.propTypes = {
  customSurveyId: PropTypes.string,
  isVisible: PropTypes.bool,
  handleClose: PropTypes.func,
  question: PropTypes.shape({
    answers: PropTypes.array,
    question: PropTypes.string,
    question_count: PropTypes.number,
    question_id: PropTypes.number,
  }),
  onDateChange: PropTypes.func,
  dateRange: PropTypes.object,
};

export default withRouter(ChartReportModal);



// WEBPACK FOOTER //
// ./src/components/reports/ChartReportModal.js